module.exports = __webpack_public_path__ + "img/11@2x.0f3e356d.jpg";